import { useHistory } from "react-router-dom";

import { Text } from "preact-i18n";

import { ModalForm } from "@cayble/ui";

import { normalizeInvite } from "../../../lib/invite";
import { ModalProps } from "../types";

/**
 * Join server modal
 */
export default function JoinServer({ ...props }: ModalProps<"join_server">) {
    const history = useHistory();

    return (
        <ModalForm
            {...props}
            title={<Text id="app.context_menu.join_server" />}
            schema={{
                invite: "text",
            }}
            data={{
                invite: {
                    field: (
                        <Text id="app.special.modals.fields.invite" />
                    ) as React.ReactChild,
                    placeholder: "testeurs",
                },
            }}
            callback={async ({ invite }) => {
                const code = normalizeInvite(invite);
                if (code) history.push(`/invite/${code}`);
            }}
            submit={{
                children: <Text id="app.special.modals.actions.join" />,
            }}
        />
    );
}
